<ng-container *vsLet="key$ | async as key">
  <div class="flex flex-col gap-4 text-gray-700 text-sm">
    <div class="text-justify">
      The Stripe Tax app enables accurate Canadian and United States tax calculation at checkout by integrating your own
      Stripe secret key. Once enabled, tax is calculated via Stripe Tax for Canadian addresses while your existing
      Authorize.net payment flow remains unchanged.
    </div>
    <div class="flex flex-col gap-1.5 pb-4">
      <label for="stripe-secret" class="font-medium">Secret key</label>
      <input
        type="text"
        [ngClass]="secretKeyControl.value ? 'blur-sm hover:blur-none mt-1' : 'mt-1'"
        vsInput
        theme="primary"
        [formControl]="secretKeyControl"
        id="stripe-secret"
      />
    </div>
    <div class="flex justify-end items-center gap-2" *ngIf="canManageStripeTax$ | async">
      <button
        vs-button
        appearance="outline"
        theme="default"
        [disabled]="!secretKeyControl.value"
        (click)="key ? disableStripeTaxDialog.open() : enable(secretKeyControl.value)"
      >
        {{key ? 'Disable' : 'Enable'}}
      </button>
      <button
        vs-button
        appearance="default"
        theme="primary"
        [disabled]="(!key) || (key && secretKeyControl.value === key)"
        (click)="update(secretKeyControl.value)"
      >
        Update key
      </button>
    </div>
  </div>
</ng-container>

<vs-dialog #disableStripeTaxDialog [config]="{dialogContainerClass: 'w-full md:w-96'}">
  <vs-dialog-header
    [config]="{icon: 'coins-stacked-03', iconTheme:'primary', title: 'Disable Stripe Tax app?' , subtitle: 'Are you sure you want to disable this app? Canadian tax will no longer be calculated via Stripe Tax at checkout.', mode: 'simple', hideCloseButton: true}"
  ></vs-dialog-header>
  <div class="w-full flex flex-row gap-2 justify-between">
    <button vs-button class="w-1/2" appearance="outline" (click)="disableStripeTaxDialog.close();">Cancel</button>
    <button vs-button class="w-1/2" theme="danger" (click)="disable(); disableStripeTaxDialog.close()">
      Disable Application
    </button>
  </div>
</vs-dialog>
